module.exports = __webpack_public_path__ + "img/menu_omega_group.5b78601b.png";